import { Component } from '@angular/core';

@Component({
  selector: 'app-bps-admin-job-history',
  standalone: false,
  templateUrl: './bps-admin-job-history.component.html',
  styleUrl: './bps-admin-job-history.component.scss'
})
export class BpsAdminJobHistoryComponent {

}
